import { configureStore } from "@reduxjs/toolkit";

import notificationsReducer from "../features/notifications/notificationsSlice";
import contentReducer from "../features/content/contentSlice"
import authReducer from "../features/auth/authSlice"
import userReducer from "../features/user/userSlice"
import mapReducer from "../features/map/mapSlice"
import uiReducer from "../features/ui/uiSlice";

export const store = configureStore({
  reducer: {    
    auth: authReducer,
    user: userReducer,    
    content: contentReducer,
    ui: uiReducer,
    map: mapReducer,
    notifications: notificationsReducer
  },
});
